<ppl-radio-group [value]="value"
                 [hasContainerClass]="false"
                 (valueChange)="onValueChange($event)">
  <ppl-radio-button *ngFor="let option of options; trackBy: trackById"
                    [value]="option.id">
    <div class="method-info-container">
      <ppl-icon [svgIcon]="option.icon"
                height="32px"
                width="32px"></ppl-icon>
      <div>
        <div class="method-info-name"
             [ngSwitch]="option.type">
          <ng-container *ngSwitchCase="TwoFAType.AUTH_APP"
                        i18n="@@Authenticator_App">Authenticator App</ng-container>
          <ng-container *ngSwitchCase="TwoFAType.EMAIL"
                        i18n="@@Email_Message">Email Message</ng-container>
          <ng-container *ngSwitchCase="TwoFAType.SMS"
                        i18n="@@Text_Message_(SMS)">Text Message (SMS)</ng-container>
          <ng-container *ngSwitchCase="TwoFAType.BACKUP_CODES"
                        i18n="@@Use_Backup_Code">Use Backup Code</ng-container>
          <ng-container *ngSwitchCase="TwoFAType.DUMMY">Dummy (Test)</ng-container>
        </div>
        <div class="method-info-value"
             [ngSwitch]="option.type">
          <ng-container *ngSwitchCase="TwoFAType.AUTH_APP">{{ option.name }}</ng-container>
          <ng-container *ngSwitchCase="TwoFAType.EMAIL">{{ option.value }}</ng-container>
          <ng-container *ngSwitchCase="TwoFAType.SMS">{{ option.value }}</ng-container>
          <ng-container *ngSwitchCase="TwoFAType.BACKUP_CODES"
                        i18n="@@Verify_via_pre-generated_codes">Verify via pre-generated codes</ng-container>
          <ng-container *ngSwitchCase="TwoFAType.DUMMY">{{ option.value }}</ng-container>
        </div>
      </div>
    </div>
  </ppl-radio-button>
</ppl-radio-group>
